var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasFlowMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_5120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 565.602H853.393V687.779L780.204 639.404L673.861 684.677L566.264 639.403L473.058 725.61L372.342 754.14L327.928 717.548L292.897 664.831L259.742 696.462L185.926 635.062L134.63 642.505L77.08 593.509L2.63965 574.904L3.264 565.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 565.602V566.203H852.787V686.655L780.267 638.722L673.859 684.023L566.139 638.697L472.75 725.071L372.483 753.474L328.385 717.142L293.001 663.896L259.714 695.653L186.108 634.428L134.816 641.869L77.3663 592.961L3.27796 574.443L3.86903 565.642L3.26384 565.602V566.203V565.602L2.65865 565.562L2 575.364L76.7934 594.058L134.445 643.14L185.745 635.697L259.769 697.27L292.792 665.767L327.47 717.953L372.201 754.805L473.364 726.148L566.39 640.109L673.861 685.331L780.141 640.085L854 688.903V565H2.69597L2.65865 565.562L3.26384 565.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 565.602V566.203H852.787V686.655L780.267 638.722L673.859 684.023L566.139 638.697L472.75 725.071L372.483 753.474L328.385 717.142L293.001 663.896L259.714 695.653L186.108 634.428L134.816 641.869L77.3663 592.961L3.27796 574.443L3.86903 565.642L3.26384 565.602ZM3.26384 565.602V566.203V565.602ZM3.26384 565.602L2.65865 565.562L2 575.364L76.7934 594.058L134.445 643.14L185.745 635.697L259.769 697.27L292.792 665.767L327.47 717.953L372.201 754.805L473.364 726.148L566.39 640.109L673.861 685.331L780.141 640.085L854 688.903V565H2.69597L2.65865 565.562L3.26384 565.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.543 355.58C471.353 382 438.833 437 462.353 464C482.353 487 492.353 456 508.353 478",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.853 476.5C514.303 477.39 510.023 481.5 507.853 481.5C506.853 481.5 506.293 477.38 508.193 475.84C509.853 474.5 512.853 474.5 513.853 476.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.853 174.5C433.853 171.5 436.853 172.5 435.853 176.5C435.493 177.94 437.023 179.14 437.853 179.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.363 171H417.233V484.5H432.363V171Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.913 166H417.793V170.5H430.913V166Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.913 154H415.793V165.5H432.913V154Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.094 170.797L437.737 176.175L501.06 239.254L506.416 233.877L443.094 170.797Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.135 177.78L435.627 181.301L438.829 184.491L442.337 180.97L439.135 177.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.13 233.776L493.133 235.781L497.334 239.966L499.331 237.961L495.13 233.776Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.636 194.276L454.133 195.785L461.841 203.463L463.344 201.954L455.636 194.276Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.353 534C327.353 542 330.353 557 357.853 556.5C375.583 556.18 393.693 551.06 393.853 531.5C394.353 472 394.353 378 394.853 355.5",
    stroke: "#F7F9F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.013 361H406.893V384H442.013V361Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.079 538.232L219.063 541.216C220.211 542.364 222.072 542.364 223.22 541.216L223.228 541.209C224.376 540.061 224.376 538.199 223.228 537.051L220.244 534.067C219.095 532.919 217.234 532.919 216.086 534.067L216.079 534.074C214.931 535.223 214.931 537.084 216.079 538.232Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.643 497H260.283C255.33 496.996 250.563 498.889 246.963 502.29L216.903 532.54C216.751 532.701 216.646 532.9 216.602 533.117C216.557 533.333 216.573 533.558 216.649 533.766C216.725 533.973 216.857 534.156 217.031 534.293C217.205 534.429 217.413 534.515 217.633 534.54C218.708 535.078 219.631 535.879 220.314 536.868C220.998 537.858 221.42 539.004 221.543 540.2L221.893 543.51C222.518 545.119 223.699 546.451 225.221 547.266C226.743 548.08 228.507 548.323 230.193 547.95L233.193 547.29L260.313 520.65C261.555 519.458 263.21 518.791 264.933 518.79H430.643V497Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.752 534.273L631.768 537.257C630.62 538.405 630.62 540.267 631.768 541.415L631.775 541.422C632.924 542.57 634.785 542.57 635.933 541.422L638.917 538.438C640.065 537.29 640.065 535.428 638.917 534.28L638.91 534.273C637.762 533.125 635.9 533.125 634.752 534.273Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.353 497.19H594.713C599.663 497.19 604.427 499.078 608.033 502.47L638.093 532.73C638.248 532.889 638.356 533.089 638.403 533.307C638.45 533.524 638.434 533.751 638.358 533.96C638.281 534.169 638.147 534.352 637.971 534.489C637.795 534.625 637.584 534.709 637.363 534.73C636.287 535.269 635.365 536.07 634.68 537.059C633.995 538.048 633.569 539.194 633.443 540.39L633.103 543.71C632.477 545.319 631.296 546.65 629.773 547.462C628.251 548.275 626.487 548.515 624.803 548.14L621.803 547.49L594.683 520.85C593.442 519.654 591.786 518.987 590.063 518.99H424.353V497.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.353 483H299.353V520.5H360.353V483Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.394 512.575L221.858 516.11L248.594 542.846L252.13 539.311L225.394 512.575Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.216 511.164L226.095 513.285L230.203 517.393L232.324 515.272L228.216 511.164Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.528 516.471L231.406 518.592L235.515 522.7L237.636 520.579L233.528 516.471Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.823 521.771L236.702 523.892L240.81 528L242.932 525.879L238.823 521.771Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.125 527.074L242.004 529.195L246.112 533.303L248.234 531.182L244.125 527.074Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.438 532.381L247.316 534.502L251.425 538.61L253.546 536.489L249.438 532.381Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.032 520.357L216.911 522.479L221.019 526.587L223.141 524.466L219.032 520.357Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.328 525.657L222.207 527.779L226.315 531.887L228.437 529.766L224.328 525.657Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.633 530.967L227.512 533.089L231.62 537.197L233.741 535.076L229.633 530.967Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.943 536.267L232.821 538.389L236.93 542.497L239.051 540.376L234.943 536.267Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.239 541.567L238.117 543.689L242.225 547.797L244.347 545.676L240.239 541.567Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.245 522.832L216.538 523.539L220.307 527.308L221.014 526.601L217.245 522.832Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.558 528.125L221.851 528.832L225.619 532.601L226.327 531.894L222.558 528.125Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.854 533.425L227.146 534.132L230.915 537.901L231.622 537.194L227.854 533.425Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.891 538.465L232.184 539.172L235.952 542.941L236.66 542.234L232.891 538.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.468 544.035L237.761 544.742L241.53 548.511L242.237 547.804L238.468 544.035Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.847 516.114L218.312 519.65L245.047 546.385L248.583 542.85L221.847 516.114Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.353 453H307.353V481.5H358.353V453Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.353 458H352.853V478.5H360.353V458Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.853 508.5H427.353V522L424.653 523L421.853 522V508.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.353 482H310.353V486H356.353V482Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.353 486.5H310.353V492H356.353V486.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.353 487.5H301.353V493H308.353V487.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.353 481.5H301.353V487H308.353V481.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.353 478.5H301.353V482H308.353V478.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.353 474.5H302.353V478H307.353V474.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.353 472H302.353V474H307.353V472Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.353 473H314.353V481H319.353V473Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.853 478.5H321.853V480.5H328.853V478.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.853 478.5H330.853V480.5H337.853V478.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.853 478.5H339.853V480.5H346.853V478.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.853 478.5H348.853V480.5H355.853V478.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.853 478.5H312.853V480.5H319.853V478.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.353 520H344.853V533.5H353.353V520Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.353 521H317.853V526H337.353V521Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.353 526H318.853V532H336.353V526Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.353 532H320.853V535H334.353V532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.853 520H338.853V535.5H344.853V520Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.353 520H352.853V535.5H360.353V520Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.353 524H360.853V531.5H363.353V524Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.353 514H360.853V521.5H363.353V514Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.353 503H360.853V510.5H363.353V503Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.353 493H360.853V500.5H363.353V493Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.353 483H360.853V490.5H363.353V483Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.853 493H349.853V497.5L343.853 512V493Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.853 493H316.853V497.5L322.853 512V493Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.353 489.19H562.353V527H567.353V489.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.353 490.19H559.353V496H562.353V490.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.353 497.69H559.353V503.5H562.353V497.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.353 505.19H559.353V511H562.353V505.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.353 512.69H559.353V518.5H562.353V512.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.353 520.19H559.353V526H562.353V520.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.353 490.19H572.353V496H575.353V490.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.353 497.69H572.353V503.5H575.353V497.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.353 505.19H572.353V511H575.353V505.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.353 512.69H572.353V518.5H575.353V512.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.353 520.19H572.353V526H575.353V520.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.353 490.67H575.353V496H576.353V490.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.353 498.17H575.353V503.5H576.353V498.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.353 505.67H575.353V511H576.353V505.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.353 512.8H575.353V518.13H576.353V512.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.353 520.67H575.353V526H576.353V520.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.353 489.19H567.353V527H572.353V489.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.853 491.58L523.003 483.33L537.073 497.24H519.853L514.853 491.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.043 245.69H383.043C380.834 245.69 379.043 247.481 379.043 249.69V352.69C379.043 354.899 380.834 356.69 383.043 356.69H467.043C469.252 356.69 471.043 354.899 471.043 352.69V249.69C471.043 247.481 469.252 245.69 467.043 245.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.563 262.69H382.523C382.258 262.69 382.043 262.905 382.043 263.17V336.21C382.043 336.475 382.258 336.69 382.523 336.69H383.563C383.828 336.69 384.043 336.475 384.043 336.21V263.17C384.043 262.905 383.828 262.69 383.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.563 262.69H388.523C388.258 262.69 388.043 262.905 388.043 263.17V336.21C388.043 336.475 388.258 336.69 388.523 336.69H389.563C389.828 336.69 390.043 336.475 390.043 336.21V263.17C390.043 262.905 389.828 262.69 389.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.563 262.69H394.523C394.258 262.69 394.043 262.905 394.043 263.17V336.21C394.043 336.475 394.258 336.69 394.523 336.69H395.563C395.828 336.69 396.043 336.475 396.043 336.21V263.17C396.043 262.905 395.828 262.69 395.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.563 262.69H400.523C400.258 262.69 400.043 262.905 400.043 263.17V336.21C400.043 336.475 400.258 336.69 400.523 336.69H401.563C401.828 336.69 402.043 336.475 402.043 336.21V263.17C402.043 262.905 401.828 262.69 401.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.563 262.69H406.523C406.258 262.69 406.043 262.905 406.043 263.17V336.21C406.043 336.475 406.258 336.69 406.523 336.69H407.563C407.828 336.69 408.043 336.475 408.043 336.21V263.17C408.043 262.905 407.828 262.69 407.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.563 262.69H412.523C412.258 262.69 412.043 262.905 412.043 263.17V336.21C412.043 336.475 412.258 336.69 412.523 336.69H413.563C413.828 336.69 414.043 336.475 414.043 336.21V263.17C414.043 262.905 413.828 262.69 413.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.563 262.69H418.523C418.258 262.69 418.043 262.905 418.043 263.17V336.21C418.043 336.475 418.258 336.69 418.523 336.69H419.563C419.828 336.69 420.043 336.475 420.043 336.21V263.17C420.043 262.905 419.828 262.69 419.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.563 262.69H424.523C424.258 262.69 424.043 262.905 424.043 263.17V336.21C424.043 336.475 424.258 336.69 424.523 336.69H425.563C425.828 336.69 426.043 336.475 426.043 336.21V263.17C426.043 262.905 425.828 262.69 425.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.563 262.69H429.523C429.258 262.69 429.043 262.905 429.043 263.17V336.21C429.043 336.475 429.258 336.69 429.523 336.69H430.563C430.828 336.69 431.043 336.475 431.043 336.21V263.17C431.043 262.905 430.828 262.69 430.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.563 262.69H436.523C436.258 262.69 436.043 262.905 436.043 263.17V336.21C436.043 336.475 436.258 336.69 436.523 336.69H437.563C437.828 336.69 438.043 336.475 438.043 336.21V263.17C438.043 262.905 437.828 262.69 437.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.563 262.69H441.523C441.258 262.69 441.043 262.905 441.043 263.17V336.21C441.043 336.475 441.258 336.69 441.523 336.69H442.563C442.828 336.69 443.043 336.475 443.043 336.21V263.17C443.043 262.905 442.828 262.69 442.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.563 262.69H447.523C447.258 262.69 447.043 262.905 447.043 263.17V336.21C447.043 336.475 447.258 336.69 447.523 336.69H448.563C448.828 336.69 449.043 336.475 449.043 336.21V263.17C449.043 262.905 448.828 262.69 448.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.563 262.69H453.523C453.258 262.69 453.043 262.905 453.043 263.17V336.21C453.043 336.475 453.258 336.69 453.523 336.69H454.563C454.828 336.69 455.043 336.475 455.043 336.21V263.17C455.043 262.905 454.828 262.69 454.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.563 262.69H459.523C459.258 262.69 459.043 262.905 459.043 263.17V336.21C459.043 336.475 459.258 336.69 459.523 336.69H460.563C460.828 336.69 461.043 336.475 461.043 336.21V263.17C461.043 262.905 460.828 262.69 460.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.563 262.69H465.523C465.258 262.69 465.043 262.905 465.043 263.17V336.21C465.043 336.475 465.258 336.69 465.523 336.69H466.563C466.828 336.69 467.043 336.475 467.043 336.21V263.17C467.043 262.905 466.828 262.69 466.563 262.69Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.533 270.05H408.173C407.714 270.05 407.343 270.422 407.343 270.88V280.86C407.343 281.318 407.714 281.69 408.173 281.69H444.533C444.991 281.69 445.363 281.318 445.363 280.86V270.88C445.363 270.422 444.991 270.05 444.533 270.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.153 249.05H413.933C413.436 249.05 413.033 249.453 413.033 249.95V257.79C413.033 258.287 413.436 258.69 413.933 258.69H466.153C466.65 258.69 467.053 258.287 467.053 257.79V249.95C467.053 249.453 466.65 249.05 466.153 249.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.603 512.782L602.867 539.517L606.403 543.053L633.138 516.317L629.603 512.782Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.771 511.365L622.663 515.473L624.784 517.594L628.893 513.486L626.771 511.365Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.472 516.67L617.363 520.778L619.485 522.9L623.593 518.791L621.472 516.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.179 521.973L612.07 526.081L614.192 528.202L618.3 524.094L616.179 521.973Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.861 527.275L606.753 531.383L608.874 533.504L612.983 529.396L610.861 527.275Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.561 532.58L601.453 536.688L603.574 538.81L607.683 534.702L605.561 532.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.968 520.565L631.859 524.673L633.981 526.794L638.089 522.686L635.968 520.565Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.658 525.86L626.55 529.968L628.671 532.09L632.779 527.981L630.658 525.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.365 531.162L621.257 535.271L623.378 537.392L627.486 533.284L625.365 531.162Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.065 536.468L615.957 540.576L618.078 542.697L622.187 538.589L620.065 536.468Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.748 541.77L610.64 545.879L612.761 548L616.869 543.892L614.748 541.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.753 523.022L633.984 526.791L634.691 527.498L638.46 523.729L637.753 523.022Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.453 528.317L628.685 532.086L629.392 532.793L633.161 529.024L632.453 528.317Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.136 533.62L623.367 537.388L624.074 538.096L627.843 534.327L627.136 533.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.096 538.667L618.327 542.436L619.034 543.143L622.803 539.374L622.096 538.667Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.543 544.227L612.774 547.996L613.482 548.703L617.25 544.935L616.543 544.227Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.139 516.312L606.403 543.047L609.939 546.583L636.675 519.847L633.139 516.312Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.323 488.95H284.323V526.76H289.323V488.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.323 489.95H289.323V495.76H292.323V489.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.323 497.45H289.323V503.26H292.323V497.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.323 504.95H289.323V510.76H292.323V504.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.323 512.45H289.323V518.26H292.323V512.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.323 519.95H289.323V525.76H292.323V519.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.323 489.95H276.323V495.76H279.323V489.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.323 497.45H276.323V503.26H279.323V497.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.323 504.95H276.323V510.76H279.323V504.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.323 512.45H276.323V518.26H279.323V512.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.323 519.95H276.323V525.76H279.323V519.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.323 490.43H275.323V495.76H276.323V490.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.323 497.93H275.323V503.26H276.323V497.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.323 505.43H275.323V510.76H276.323V505.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.323 512.56H275.323V517.89H276.323V512.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.323 520.43H275.323V525.76H276.323V520.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.323 488.95H279.323V526.76H284.323V488.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.323 488.95H375.323V526.76H380.323V488.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.323 489.95H380.323V495.76H383.323V489.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.323 497.45H380.323V503.26H383.323V497.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.323 504.95H380.323V510.76H383.323V504.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.323 512.45H380.323V518.26H383.323V512.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.323 519.95H380.323V525.76H383.323V519.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.323 489.95H367.323V495.76H370.323V489.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.323 497.45H367.323V503.26H370.323V497.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.323 504.95H367.323V510.76H370.323V504.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.323 512.45H367.323V518.26H370.323V512.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.323 519.95H367.323V525.76H370.323V519.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.323 490.43H366.323V495.76H367.323V490.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.323 497.93H366.323V503.26H367.323V497.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.323 505.43H366.323V510.76H367.323V505.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.323 512.56H366.323V517.89H367.323V512.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.323 520.43H366.323V525.76H367.323V520.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.323 488.95H370.323V526.76H375.323V488.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.973 466.28L367.433 473L357.973 466.28Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.973 466.28L367.433 473",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.283 468.21C358.426 468.21 359.353 467.283 359.353 466.14C359.353 464.997 358.426 464.07 357.283 464.07C356.14 464.07 355.213 464.997 355.213 466.14C355.213 467.283 356.14 468.21 357.283 468.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.353 458C357.353 447 362.353 442 381.353 439C400.123 436 401.353 432 399.353 357",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.353 458C360.353 450 372.353 451 397.353 441C449.353 420.21 443.353 395 442.353 357",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.353 472C304.353 459 308.353 442 359.353 442C402.943 442 439.353 429 438.353 391",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.353 471C301.353 449 307.353 438 358.353 438C401.943 438 413.353 429 412.353 391",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.353 439.19H311.353V473H354.353V439.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.353 446.19H321.353V452H345.353V446.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.353 491H419.853V497.5H430.353V491Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.353 490H394.853V496.5H454.353V490Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.073 485H434.633C435.089 485 435.526 485.181 435.849 485.504C436.171 485.826 436.353 486.264 436.353 486.72V489.5H413.353V486.72C413.353 486.264 413.534 485.826 413.856 485.504C414.179 485.181 414.616 485 415.073 485Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.353 487H422.853V490.5H427.353V487Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.733 485H397.233V489.5H407.733V485Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.983 480H400.983V484.5H403.983V480Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.733 485H441.233V489.5H451.733V485Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.917 480.437L508.234 482.049L515.498 489.631L517.18 488.019L509.917 480.437Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.918 478.439L510.235 480.051L517.499 487.633L519.181 486.021L511.918 478.439Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.918 476.441L512.235 478.053L519.499 485.635L521.181 484.024L513.918 476.441Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.013 384H403.893V387H445.013V384Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.353 366H402.353V378H407.353V366Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.353 366H439.893V378H446.353V366Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.353 369H446.893V375H448.353V369Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.353 387H436.893V391H439.353V387Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.353 387H410.893V391H413.353V387Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.013 357H403.893V361H445.013V357Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.353 195H415.853V196.5H433.353V195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.353 205.92H415.853V206.5H435.353V205.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.353 193.48H414.353V197.5H416.353V193.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.353 194H411.353V196.5H413.353V194Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.353 178H415.853V179.5H433.353V178Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.353 176.48H414.353V180.5H416.353V176.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.353 177H411.353V179.5H413.353V177Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.983 480H444.983V484.5H447.983V480Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.853 495.5H414.893L424.853 507.5L434.963 495.5H454.353V502.5L442.503 507.5H405.453L394.853 502.5V495.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.353 501H418.353V508H431.353V501Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.103 387.25C433.111 387.25 439.603 380.758 439.603 372.75C439.603 364.742 433.111 358.25 425.103 358.25C417.094 358.25 410.603 364.742 410.603 372.75C410.603 380.758 417.094 387.25 425.103 387.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.103 381.75C430.073 381.75 434.103 377.721 434.103 372.75C434.103 367.779 430.073 363.75 425.103 363.75C420.132 363.75 416.103 367.779 416.103 372.75C416.103 377.721 420.132 381.75 425.103 381.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.853 199.5C438.853 197.5 436.303 192.05 438.853 189.5C439.422 188.873 440.117 188.372 440.892 188.029C441.667 187.686 442.505 187.509 443.353 187.509C444.2 187.509 445.038 187.686 445.813 188.029C446.588 188.372 447.283 188.873 447.853 189.5C451.853 193.5 445.693 200.73 449.853 203.5C452.853 205.5 455.853 202.5 458.853 200.5",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.353 241.5H413.353V245.5H436.353V241.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.103 245.67C415.246 245.67 416.173 244.743 416.173 243.6C416.173 242.457 415.246 241.53 414.103 241.53C412.96 241.53 412.033 242.457 412.033 243.6C412.033 244.743 412.96 245.67 414.103 245.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.103 245.67C436.246 245.67 437.173 244.743 437.173 243.6C437.173 242.457 436.246 241.53 435.103 241.53C433.96 241.53 433.033 242.457 433.033 243.6C433.033 244.743 433.96 245.67 435.103 245.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_5120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasFlowMonitor);
export default __webpack_public_path__ + "static/media/gas-flow-monitor.81da06d99dc3c034a055f4aa22b9fb0c.svg";
export { ForwardRef as ReactComponent };